/* claude: Mobile Nav A — Accordion.
 *
 * THE UX FIX. Dillon: "when I click on markers, it leads me to all markers.
 * Clicking anywhere on this markers thing should open up markers, and that way
 * I can click on all markers if I want. Otherwise, I'm going to accidentally
 * click it."
 *
 * So a parent row is a <button>, not an <a>. It has no href and cannot navigate
 * under any circumstance — the fix is structural, not a preventDefault() that a
 * later handler could undo. The full collection is reachable only through the
 * explicit "ALL <SECTION>" child link inside the open panel.
 *
 * aria-expanded on the button is the single source of truth for open/closed;
 * the CSS keys off it, so markup rendered by Liquid is already collapsed before
 * this file runs and there is no expand-then-collapse flash.
 *
 * Owned by the mobile nav work. Do not fold into empire.js.
 */
(function () {
  'use strict';

  var PRESS_CLASS = 'is-pressed';

  function init() {
    var nav = document.getElementById('site-mobile-nav');
    if (!nav || nav.dataset.bsMnavBound === 'true') { return; }
    nav.dataset.bsMnavBound = 'true';

    var toggles = Array.prototype.slice.call(
      nav.querySelectorAll('[data-bs-mnav-toggle]')
    );

    function panelFor(button) {
      var id = button.getAttribute('aria-controls');
      return id ? nav.querySelector('#' + CSS.escape(id)) : null;
    }

    function setOpen(button, open) {
      button.setAttribute('aria-expanded', open ? 'true' : 'false');
      var panel = panelFor(button);
      if (panel) { panel.setAttribute('data-bs-mnav-open', open ? 'true' : 'false'); }
    }

    function collapseAll(except) {
      toggles.forEach(function (button) {
        if (button !== except) { setOpen(button, false); }
      });
    }

    toggles.forEach(function (button) {
      setOpen(button, false);

      button.addEventListener('click', function (event) {
        // the row is a <button type="button">, but stop the click from reaching
        // the theme's drawer handlers all the same
        event.preventDefault();
        event.stopPropagation();

        var willOpen = button.getAttribute('aria-expanded') !== 'true';

        // one section open at a time (artboard annotation)
        collapseAll(button);
        setOpen(button, willOpen);

        if (willOpen) {
          // keep the row that was just opened on screen; the drawer scrolls,
          // the page behind it does not
          window.requestAnimationFrame(function () {
            var panel = nav.querySelector('.mobile-nav-panel');
            if (!panel) { return; }
            var rowTop = button.getBoundingClientRect().top;
            var panelTop = panel.getBoundingClientRect().top;
            var delta = rowTop - panelTop;
            if (delta < 0 || rowTop > panelTop + panel.clientHeight - 120) {
              panel.scrollTop += delta;
            }
          });
        }
      });
    });

    /* ---- pressed state (spec panel 02) --------------------------------
       iOS Safari only applies :active to <a> and elements with a touch
       handler, so the class is driven from pointer events. Pointer, not
       touch, so a mouse in device-emulation behaves identically. */
    var pressables = nav.querySelectorAll(
      '.bs-mnav-row, .bs-mnav-child, .navmenu-item--v2-secondary > .navmenu-link'
    );

    Array.prototype.forEach.call(pressables, function (el) {
      function press() { el.classList.add(PRESS_CLASS); }
      function release() { el.classList.remove(PRESS_CLASS); }

      el.addEventListener('pointerdown', press);
      el.addEventListener('pointerup', release);
      el.addEventListener('pointercancel', release);
      el.addEventListener('pointerleave', release);
      el.addEventListener('blur', release);
    });

    window.BSMobileNav = {
      collapseAll: function () {
        collapseAll(null);
        Array.prototype.forEach.call(pressables, function (el) {
          el.classList.remove(PRESS_CLASS);
        });
      }
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
